<template>
    <div class="d-flex flex-row gap-3">
        <div v-if="!noImage" class="d-flex flex-column justify-content-center">
            <StoreImage :store="store" :style="imageStyle" />
        </div>
        <div>
            <div class="text-dark">
                {{ store.attributes.name }}
            </div>
            <div class="font-size-sm mt-n1 text-muted">
                <StoreAddress :store="store"/>
            </div>
        </div>
    </div>
</template>

<script>
import StoreImage from "./StoreImage.vue";
import StoreAddress from "./StoreAddress.vue";

export default {
    components: {StoreImage, StoreAddress},

    props: {
        store: Object,
        noImage: Boolean,
        imageStyle: {
            type: String,
            default: 'height: 2.4em; width: 64px;'
        }
    }
}
</script>
